import type { CSSProperties } from 'react';

export interface PanelBounds {
  left: number;
  top: number;
  width: number;
  height: number;
}

export function clampStepDragStyle(style: CSSProperties | undefined, bounds: PanelBounds | null): CSSProperties | undefined {
  if (!style || style.position !== 'fixed' || !bounds) return style;
  const translation = /^translate\((-?[\d.]+)px,\s*(-?[\d.]+)px\)$/.exec(style.transform || '');
  if (!translation && style.transform != null) return style;
  if (![style.left, style.top, style.width, style.height].every(value => typeof value === 'number' && Number.isFinite(value))) return style;
  const width = Math.min(style.width as number, bounds.width);
  const height = Math.min(style.height as number, bounds.height);
  const left = style.left as number;
  const top = style.top as number;
  const nextLeft = Math.max(bounds.left, Math.min(left + Number(translation?.[1] || 0), bounds.left + bounds.width - width));
  const nextTop = Math.max(bounds.top, Math.min(top + Number(translation?.[2] || 0), bounds.top + bounds.height - height));
  return {
    ...style,
    width,
    height,
    maxHeight: bounds.height,
    overflow: 'hidden',
    boxSizing: 'border-box',
    transform: `translate(${nextLeft - left}px, ${nextTop - top}px)`,
  };
}

export function shouldCloseStepBackdrop(pressedBackdrop: boolean, releasedBackdrop: boolean, dragging: boolean): boolean {
  return pressedBackdrop && releasedBackdrop && !dragging;
}

export function notificationOverrideState(config: { targets?: Array<{ type?: string }>; channelTypes?: string[]; toEmails?: string; ccEmails?: string; bccEmails?: string; adHocEmails?: string; channelId?: string }) {
  const targets = config.targets || [];
  const hasNonChannelTargets = targets.some(target => ['user', 'group', 'oncall'].includes((target.type || '').toLowerCase()));
  const hasAdHoc = [config.toEmails, config.ccEmails, config.bccEmails, config.adHocEmails].some(value => !!value?.trim());
  const hasLegacyAdHocRecipients = !!config.adHocEmails?.trim();
  const canSelectDeliveryType = hasNonChannelTargets || (!targets.length && hasAdHoc) || hasLegacyAdHocRecipients;
  return { deliveryEnabled: canSelectDeliveryType, expanded: !!config.channelTypes?.length || hasAdHoc };
}